import PropTypes from 'prop-types'
import React from "react"
import { Modal, ModalBody, CloseButton } from "reactstrap"
import Lottie from 'react-lottie';
import animationData from '../../assets/lotties/delete-warning';
import { owner, supervisor, deleteItem } from 'helpers/formUtils';

const ConfirmModal = ({ show, onConfirmClick, toggle, role }) => {
    
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  // Function to get the appropriate message based on role
  const getMessage = () => {
    if (role === 'supervisor') return supervisor.message;
    if (role === 'deleteItem') return deleteItem.message;
    return owner.message;
  };

  // Function to get the appropriate note based on role
  const getNote = () => {
    if (role === 'supervisor') return supervisor.note;
    if (role === 'deleteItem') return deleteItem.note;
    return owner.note;
  };

  return (
    <Modal isOpen={show} toggle={toggle} centered={true}>
      <ModalBody>
        <div className="flex items-center space-x-3">
            <Lottie 
                options={defaultOptions}
                height={60}
                width={90}
            />
            <div className='space-y-3'>
                <p className='text-base text-green-800 font-medium'>{getMessage()}</p>
                <p className='text-sm'>{getNote()}</p>
            </div>
        </div>
        <div className='flex mt-3 justify-evenly'>
            <button
                className="common-cancel-button"
                onClick={toggle}
            >
                Cancel
            </button>
            <button
                className='common-button'
                onClick={()=>{
                    onConfirmClick();
                    toggle();
                }}
            >
                Confirm
            </button>
        </div>
      </ModalBody>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  toggle: PropTypes.func,
  onConfirmClick: PropTypes.func,
  show: PropTypes.any
}

export default ConfirmModal
